import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfig } from './app.config';
import { LOCAL_STORAGE } from '@ng-toolkit/universal';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  public dashboardView: BehaviorSubject<string> = new BehaviorSubject<string>('');

  public editProfileFlag: BehaviorSubject<string> = new BehaviorSubject<string>('');

  public themeFlag: BehaviorSubject<string> = new BehaviorSubject<string>('');

  public toggleMenu: BehaviorSubject<string> = new BehaviorSubject<string>('');

  public dialogFlag: BehaviorSubject<string> = new BehaviorSubject<string>('');

  public coursesFlag: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor(public http: HttpClient, public AppConfig: AppConfig, @Inject(LOCAL_STORAGE) public sessionStorage: any,) { }

  saveCourseFlag(data: any) {
    this.coursesFlag.next(data)
  }

  saveUserTime(token: any, reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'student_mock_analysis_video?video_id=', httpOptions)
      .pipe(map((response: any) => response));
  }

  userMockAnalysis(){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': 'f61a6f71-2bc4-4b50-8fe0-e2694671207f',
        'secret': '7796b364-02d2-42db-990b-bc1973b68211',
         
      })
    };

    return this.http.post('https://adminapi.iqmock.iquanta.in/business/otp/jainam.jp.shah@gmail.com',{}, httpOptions)
      .pipe(map((response: any) => response));
  }

  ediProfile(data: any) {
    this.editProfileFlag.next(data)
  }
  
  showDashoard(data: any) {
    this.dashboardView.next(data)
  }

  saveTheme(data: any) {
    this.themeFlag.next(data)
  }

  saveDialog(data: any) {
    this.dialogFlag.next(data)
  }


  sidebarToggle(data: any) {
    this.toggleMenu.next(data)
  }

  getData() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.get('https://services.in8.nopaperforms.com/webhooks/v1/leadCapture/5802', httpOptions)
      .pipe(map((response: any) => response));
  }

  addCRMLead(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': '6669ac7eeb6f363a778463e0',
        "orgid": reqData.orgId,
        "uid":  reqData.uid,
      })
    };

    // return this.http.post('https://crm-api-prod.iquanta.in/api/v1/org/leads/details/single/create', reqData, httpOptions)
    //   .pipe(map((response: any) => response));
      return this.http.post('https://crm-api-prod.iquanta.in/api/v1/org/leads/details/single/v2/create', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  callbackLead(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': '6669ac7eeb6f363a778463e0',
        "orgid": "66dec57ce200bc89284602d6",
        "uid": '66dec57ce200bc89284602d6',
      })
    };

      return this.http.post('https://crm-api-prod.iquanta.in/api/v1/org/leads/details/single/v2/create/backup', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  addCallClickData(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': '6669ac7eeb6f363a778463e0',
        "orgid": "66dec57ce200bc89284602d6",
        "uid": '66dec57ce200bc89284602d6',
      })
    };

    return this.http.post('https://crm-api-prod.iquanta.in/api/v1/org/product/entity/counter/update', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }


  addLeadSquared(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.post('https://services.in8.nopaperforms.com/webhooks/v1/leadCapture/5802', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }


  updateLeadSquared(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.post('https://services.in8.nopaperforms.com/webhooks/v1/leadCapture/5802', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  quizAnalysis(token: any, id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'student_mock_analysis_video?video_id=' + id, httpOptions)
      .pipe(map((response: any) => response));
  }


  getExamQuizStatus(token: any, id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'video_mock_status?video_id=' + id, httpOptions)
      .pipe(map((response: any) => response));

  }

  submitQuiz(token: any, reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.post(this.AppConfig.LOGIN_ENDPOINT + 'submit_mock_test_video', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  getQuiz(token: any, id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'video_question_get?video_id=' + id, httpOptions)
      .pipe(map((response: any) => response));
  }

  getPreviousPapersResults(token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    // return this.http.get(this.AppConfig.API_ENDPOINT1+'previours_papers_results/', httpOptions)
    return this.http.get(this.AppConfig.API_ENDPOINT1 + 'mock_top_scores/', httpOptions)
      .pipe(map((response: any) => response));
  }


  getPackages(token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'packages/', httpOptions)
      .pipe(map((response: any) => response));
  }

  getUserCourses(token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'course', httpOptions)
      .pipe(map((response: any) => response));
  }

  getProfile(token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'user_get', httpOptions)
      .pipe(map((response: any) => response));
  }

  saveProfileDetails(token: any, reqdata: any, id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Content-Type':  'application/json',
        // 'Authorization': 'Token ' + token
        'Authorization': 'Token ' + this.sessionStorage.getItem('usertoken'),
      })
    };

    // return this.http.put(this.AppConfig.LOGIN_ENDPOINT + 'user_put', reqdata, httpOptions)
    return this.http.put(this.AppConfig.LOGIN_ENDPOINT + 'UserProfilEdit/' + id, reqdata, httpOptions)
      .pipe(map((response: any) => response));
  }

  getVideos(token: any, id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'video_get?id=' + id, httpOptions)
      .pipe(map((response: any) => response));
  }

  getOtp(token: any, id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'video_generate_otp?videoid=' + id, httpOptions)
      .pipe(map((response: any) => response));
  }


  icatMock(token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    // return this.http.get(this.AppConfig.API_ENDPOINT1 + 'brainvally_integration', httpOptions)
    return this.http.get(this.AppConfig.API_ENDPOINT1 + 'iquanta_learnyst_mock', httpOptions)
      .pipe(map((response: any) => response));
  }

  loginbrainvalley(token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    // return this.http.get(this.AppConfig.API_ENDPOINT1 + 'brainvally_integration', httpOptions)
    return this.http.get(this.AppConfig.API_ENDPOINT1 + 'learnst_integration', httpOptions)
      .pipe(map((response: any) => response));
  }

  // freeVideos(token){
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type':  'application/json',
  //       'Authorization': 'Token '+token
  //     })
  //   };

  //   return this.http.get(this.AppConfig.API_ENDPOINT1+'video/', httpOptions)
  //       .pipe(map((response: any) => response));
  // }

  payments(token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT1 + 'user_course_payment_details', httpOptions)
      .pipe(map((response: any) => response));
  }

  getnotifications(token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'user_notification', httpOptions)
      .pipe(map((response: any) => response));
  }

  checkVideo(token: any, id: any, moduleid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'course_status_details?course_id=' + id + '&module_id=' + moduleid, httpOptions)
      .pipe(map((response: any) => response));
  }

  getWhatsappLinks() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'whatsapp_get_portal', httpOptions)
      .pipe(map((response: any) => response));
  }

  getnotifyInfo(ipaddress: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'show_announcements?ip=' + ipaddress, httpOptions)
      .pipe(map((response: any) => response));
  }

  closenotifyInfo(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Content-Type': 'application/json'
      })
    };

    return this.http.post(this.AppConfig.API_ENDPOINT + 'viewed_announcements', data, httpOptions)
      .pipe(map((response: any) => response));
  }


  getVideoTest(token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT1 + 'video_link_details?videoid=1', httpOptions)
      .pipe(map((response: any) => response));
  }
  getWishList(token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'WishListGet', httpOptions)
      .pipe(map((response: any) => response));
  }

  removeWishlist(token: any, id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.delete(this.AppConfig.LOGIN_ENDPOINT + 'WishListProductDelete?product_id=' + id, httpOptions)
      .pipe(map((response: any) => response));
  }

  getReferalList() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT1 + 'ReferralAmountlist', httpOptions)
      .pipe(map((response: any) => response));
  }

  saveUpi(reqData: any, token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.put(this.AppConfig.LOGIN_ENDPOINT + 'UserUpiEdit', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  requestPayment(reqData: any, token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.post(this.AppConfig.LOGIN_ENDPOINT + 'UserReferralRequestPost', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  getReferralDetails(id: any, token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT1 + 'UserEarnAmountDetails/' + id, httpOptions)
      .pipe(map((response: any) => response));
  }

  getProductReferalList(token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT1 + 'ProductReferralAmountlist', httpOptions)
      .pipe(map((response: any) => response));
  }


  getCustomCourseReferral(token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT1 + 'CustomCourseReferralAmountlist', httpOptions)
      .pipe(map((response: any) => response));
  }

  getBoardsBasedOnStandard(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'AllBoardNamesGetBasedOnStandard?standard_id=' + id, httpOptions)
      .pipe(map((response: any) => response));
  }

  getYearsPassed(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'AllYearsBasedOnStandard?standard_id=' + id, httpOptions)
      .pipe(map((response: any) => response));
  }

  getBSchoolPredictor(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'BShoolPredictorAnalysis?min10th=' + reqData.min10th + '&min12th='
      + reqData.min12th + '&mingrad=' + reqData.mingrad + '&category=' + reqData.category + '&gender='
      + reqData.gender + '&min_percen=' + reqData.min_percen, httpOptions)
      .pipe(map((response: any) => response));
  }

  getCmatCollegePredictor(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.post('https://itech-api-prod.iquanta.in/api/cmat/v1/student', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  getXatBschoolPredictor(reqData: any, id:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.post('https://itech-api-prod.iquanta.in/api/xat-result/v1/result/student/college-predicator/'+id, reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  getCuetPredictor(reqData: any, token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.post(this.AppConfig.API_ENDPOINT + 'CuetResultsCreateApi/', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  getCuetPredictorData(token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'CuetResultslist', httpOptions)
      .pipe(map((response: any) => response));
  }

  savePredictorData(reqData: any, token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.post(this.AppConfig.LOGIN_ENDPOINT + 'BSchoolInformationlist', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  getuserPredictorData(token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'BSchoolInformationlist', httpOptions)
      .pipe(map((response: any) => response));
  }

  getCmatBschoolData(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/cmat/v1/student/'+id, httpOptions)
      .pipe(map((response: any) => response));
  }

  submitUserRank(reqData: any, token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Token ' + token
      })
    };

    return this.http.post(this.AppConfig.LOGIN_ENDPOINT + 'CatResultCheckList', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  SetTargetPer(reqData: any, token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.post(this.AppConfig.LOGIN_ENDPOINT + 'UserTargetAPI?userid=' + reqData.id + '&exam=' + reqData.exam + '&target_score=' + reqData.score, {}, httpOptions)
      .pipe(map((response: any) => response));
  }


  GetTargetPer(token: any, reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'UserTargetAPI?userid=' + reqData.id, httpOptions,)
      .pipe(map((response: any) => response));
  }


  getEvents(token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/dashboard/v1/events/all/1/200?date=all', httpOptions,)
      .pipe(map((response: any) => response));
  }

  createSupportTicket(reqData: any, token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.post('https://itech-api-prod.iquanta.in/api/tidio/v1/tickets/create/as-contact', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  getSupportTickets(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/tidio/v1/tickets/all/' + id, httpOptions)
      .pipe(map((response: any) => response));
  }

  getMocksPurchased(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/dashboard/v1/events/count/mocks/details/' + id, httpOptions)
      .pipe(map((response: any) => response));
  }

  getBlogData() {
    return this.http.get('https://media.iquanta.in/media/iQuantaBlogData.json').pipe(map((response: any) => response));
  }

  getClasses(reqObj:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/mbr/class/v1/all/'+reqObj.page+'/'+reqObj.limit+'?exam='+reqObj.exam, httpOptions)
      .pipe(map((response: any) => response));
  }

  getFilterData() {
    const httpOptions = {
      headers: new HttpHeaders({
        'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/mbr/class/v1/exam/mode/all', httpOptions)
      .pipe(map((response: any) => response));
  }

  getMockEntities() {
    const httpOptions = {
      headers: new HttpHeaders({
        'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/mock/v1/list/all/entity', httpOptions)
      .pipe(map((response: any) => response));
  }

  getMockAnalysis(uid:any, entity:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/mock/v1/analytics/all/'+uid+'/'+entity, httpOptions)
      .pipe(map((response: any) => response));
  }

  getClasseswithFilter(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'token': 'f61a6f71-2bc4-4b50-8fe0-e2694671207f',
        'secret': '7796b364-02d2-42db-990b-bc1973b68211',
         
      })
    };
  
    return this.http.get('https://itech-api-prod.iquanta.in/api/mbr/class/v1/all/'+ reqData.page +'/'+ reqData.limit +'?exam='+ reqData.exam
       +'&subject='+ reqData.subject +'&mode=' + reqData.mode + '&batches='+ reqData.batch, httpOptions)
      .pipe(map((response: any) => response));
  }

  submitSOPReviewer(reqObj:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
      })
    };

    return this.http.post('https://itech-api-prod.iquanta.in/api/sop-review/v1/post', reqObj , httpOptions)
      .pipe(map((response: any) => response));
  }

  submitCareerCounselling(reqObj:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
      })
    };

    return this.http.post('https://itech-api-prod.iquanta.in/api/career-counselling/v1/post', reqObj , httpOptions)
      .pipe(map((response: any) => response));
  }

  getUserCareerAnalysis(reqObj:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/career-counselling/v1/all/'+reqObj+'/:page/:limit' , httpOptions)
      .pipe(map((response: any) => response));
  }

  submitScore(reqObj:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
      })
    };

    return this.http.post('https://itech-api-prod.iquanta.in/api/scoreVsPer/v1/sent/enquiry', reqObj , httpOptions)
      .pipe(map((response: any) => response));
  }

  editScore(reqObj:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
      })
    };

    return this.http.patch('https://itech-api-prod.iquanta.in/api/scoreVsPer/v1/update/'+reqObj.mbrId, reqObj , httpOptions)
      .pipe(map((response: any) => response));
  }

  getScore(reqObj:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/scoreVsPer/v1/all/'+reqObj , httpOptions)
      .pipe(map((response: any) => response));
  }

  getAnalysis(reqObj:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/cat-result/v1/result/student/analysis/'+reqObj , httpOptions)
      .pipe(map((response: any) => response));
  }

  deleteScore(reqObj:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
      })
    };

    return this.http.delete('https://itech-api-prod.iquanta.in/api/scoreVsPer/v1/delete/'+reqObj , httpOptions)
      .pipe(map((response: any) => response));
  }



  getSOPReviewer(id:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/sop-review/v1/all/'+id + '/:page/:limit', httpOptions)
      .pipe(map((response: any) => response));
  }

  addQuestionError(reqData: any, token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.post( this.AppConfig.LOGIN_ENDPOINT + 'post_question_error', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

  getTransactions(id:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/ai-mock-interview/v1/payment/individual/all/list/'+id + '/:page/:limit', httpOptions)
      .pipe(map((response: any) => response));
  }

  getBatches(reqObj:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get('https://itech-api-prod.iquanta.in/api/mbr/batch/v1/all/'+reqObj.pageIndex+'/'+reqObj.pageSize , httpOptions)
      .pipe(map((response: any) => response));
  }

  getSubjects() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT1 + 'subjects', httpOptions)
      .pipe(map((response: any) => response));
  }


}
